export const environment = {
  production: false,
  message: 'Building for DEV environment',
  SERVER_URL: 'https://app-dev.abm4energytransition.eu',
  SERVER_PORT: '443',
  BACKEND_URL: 'https://app-be-dev.abm4energytransition.eu',
  BACKEND_PORT: '443',
  OTA_VERSION_URL: '',
  BUILD_VERSION: 'BUILD_VERSION_CI' //Replaced by CI to something like v0.0.1
}
